import { FiMapPin } from "react-icons/fi";
import { SiFacebook, SiInstagram, SiTiktok, SiWhatsapp, SiYoutube } from "react-icons/si";
import Container from "../components/layout/Container";
import PageHeader from "../components/layout/PageHeader";
import Button from "../components/ui/Button";
import MediaCard from "../components/ui/MediaCard";
import { mobiltech } from "../data/site";

const channelIcons = {
  Instagram: SiInstagram,
  YouTube: SiYoutube,
  TikTok: SiTiktok,
  Facebook: SiFacebook,
  WhatsApp: SiWhatsapp,
  "Google Maps": FiMapPin,
};

export default function BusinessPage() {
  const channels = mobiltech.channels.filter((item) => item.enabled && item.href);
  const videos = mobiltech.videos.filter((item) => item.enabled && item.href && item.page !== false);

  return (
    <>
      <PageHeader label="Business" title={mobiltech.name} lede={mobiltech.lede} mark />
      <Container className="pb-28">
        <p className="max-w-xl text-lg leading-relaxed text-[var(--text)]">{mobiltech.note}</p>
        <div className="mt-8">
          <Button href={mobiltech.href} external variant="orange">
            Visit MobilTech
          </Button>
        </div>

        {channels.length > 0 ? (
          <section className="mt-14">
            <h2 className="kicker">Find MobilTech</h2>
            <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {channels.map((item) => {
                const Icon = channelIcons[item.label];
                return (
                  <li key={item.label}>
                    <a
                      className={`channel-link tone-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {Icon ? <Icon aria-hidden="true" size={16} /> : null}
                      <span>{item.label}</span>
                      <span className="sr-only"> (opens in a new tab)</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </section>
        ) : null}

        {videos.length > 0 ? (
          <ul className="business-cards mt-4 grid gap-4 sm:grid-cols-2">
            {videos.map((item) => (
              <li key={item.label}>
                <MediaCard
                  href={item.href}
                  image={item.image}
                  kicker={item.label}
                  title={item.title}
                  action={item.action}
                  poster={item.poster || "business"}
                  video
                />
              </li>
            ))}
          </ul>
        ) : null}
      </Container>
    </>
  );
}
